import React, { Component } from 'react'
import { connect } from 'react-redux'
import request from 'superagent'
import prefix from 'superagent-prefix'
import Cookies from 'js-cookie'

import get from 'lodash.get'
import classes from './AdminProduct.scss'
import { FormGroup, Loader } from 'components'
import Select from 'react-select'

const PREFIX = prefix(`${process.env.NODE_ENV === 'development' ? 'http://dev.chatchaipharmacy.com' : ''}/services/api`)
const PROMPT_TEXT = 'เพิ่มหมวดหมู่สินค้า: '

const mapStateToProps = (state) => ({
  tagOptions: get(state, 'product.tagOptions').asMutable(),
  companyOptions: get(state, 'company.companyOptions') || []
})
const mapDispatchToProps = (dispatch, ownProps) => ({

})

@connect(mapStateToProps, mapDispatchToProps)
class AdminProduct extends Component {
  constructor (props) {
    super(props)
    this.state = {
      productCode: '',
      companyCode: '',
      productName: '',
      tags: [],
      genericName: '',
      productGroup: '',
      promotional: 0,
      recommended: 0,
      outOfStock: false,
      description: '',
      imagePath: '',

      activeTab: `${get(props, 'location.query.unitId') || 0}`,
      saving: false,
      productImages: []
    }
  }

  _fromProductToState = (product) => ({
    productCode: get(product, 'productCode') || '',
    companyCode: get(product, 'companyCode') || '',
    productName: get(product, 'productName') || '',
    tags: (get(product, 'tags') || []).map(tag => ({ value: tag, label: tag })),
    genericName: get(product, 'genericName') || '',
    productGroup: get(product, 'productGroup') || '',
    promotional: get(product, 'promotional') || 0,
    recommended: get(product, 'recommended') || 0,
    outOfStock: get(product, 'outOfStock') === 1,
    description: get(product, 'description') || '',

    imagePath: get(product, 'imagePath') || '',
    productImages: get(product, 'productImages') || [],
    units: get(product, 'units') || []
  })

  async componentDidMount () {
    const result = await request
      .get(`/products/${this.props.params.productCode}`)
      .use(PREFIX)
      .set('Token', Cookies.get('token'))

    const result2 = await request
      .get(`/product-images/${this.props.params.productCode}`)
      .use(PREFIX)
      .set('Token', Cookies.get('token'))

    this.setState({
      ...this._fromProductToState(get(result, 'body')),
      productImages: get(result2, 'body') || []
    })
  }

  _onUnitChange = (unitId, fieldName, value, dataType) => {
    if (dataType === 'number' && value && isNaN(value)) return
    this.setState({
      units: this.state.units.map(_unit => `${_unit.unitId}` === unitId
        ? { ..._unit, [fieldName]: value }
        : _unit
      )
    })
  }

  _onThumbnailChosen = (e) => {
    const thumbnailFile = e.target.files[0]
    if (thumbnailFile) {
      try {
        this.setState({ thumbnailUploading: true }, async () => {
          const imagePath = await request
            .post(`/products/${this.props.params.productCode}/thumbnail`)
            .attach('thumbnail', thumbnailFile)
            .use(PREFIX)
            .set('Token', Cookies.get('token'))
          this.setState({ imagePath, thumbnailUploading: false })
        })
      } catch (error) {
        console.error(new Error(`Error while trying to upload new thumbnail: ${error.message}`))
        this.setState({ thumbnailUploading: false })
      }
    }
  }

  _onSave = async () => {
    try {
      this.setState({ saving: true }, async () => {
        let _request = request.put(`/products/${this.props.params.productCode}`)

        await _request
          .send({
            companyCode: this.state.companyCode,
            productName: this.state.productName,
            tags: this.state.tags,
            genericName: this.state.genericName,
            productGroup: this.state.productGroup,
            promotional: this.state.promotional,
            recommended: this.state.recommended,
            outOfStock: this.state.outOfStock,
            description: this.state.description,
            units: this.state.units || []
          })
          .use(PREFIX)
          .set('Token', Cookies.get('token'))
        this.setState({ saving: false })
      })
    } catch (error) {
      console.error(`Error while trying to save a product: ${error.message}`)
    }
  }

  _onImagesChosen = (e) => {
    const files = Object.keys(e.currentTarget.files).map(key => e.currentTarget.files[key])
    files.reduce((promise, file) => {
      return promise.then(async () => {
        const result = await request.post(`/product-images/${this.props.params.productCode}`)
          .attach('image', file)
          .use(PREFIX)
          .set('Token', Cookies.get('token'))
        this.setState({ productImages: this.state.productImages.concat([result.body]) })
      })
    }, Promise.resolve())
  }

  _onImageRemove = (imageId) => {
    try {
      this.setState({ [`${imageId}Removing`]: true }, async () => {
        await request
          .delete(`/product-images/${imageId}`)
          .use(PREFIX)
          .set('Token', Cookies.get('token'))
        this.setState({
          [`${imageId}Removing`]: false,
          productImages: this.state.productImages.filter(({ id }) => id !== imageId)
        })
      })
    } catch (error) {
      console.error(new Error(`Error while trying to remove a product image: ${error.message}.`))
      this.setState({ [`${imageId}Removing`]: false })
    }
  }

  _onOpenModal = (modalImagePath) =>
    this.setState({ modalVisible: true, modalImagePath })

  _onCloseModal = () =>
    this.setState({ modalVisible: false, modalImagePath: '' })

  _unitValue = (unitId, fieldName) =>
    get(this.state.units, `${unitId}.${fieldName}`)

  render () {
    const { companyOptions, tagOptions } = this.props
    console.log('state', this.state)
    return (
      <section className={classes.product}>
        <div className={classes.header}>
          <span>{this.props.params.productCode ? 'แก้ไขรายการสินค้า' : 'เพิ่มรายการสินค้า'}</span>
        </div>
        <div className={classes.body}>
          <div className={classes.gridContainer}>
            <div className={classes.inputSection}>
              <h2 className={classes.sectionHead}>ข้อมูลทั่วไปของสินค้า</h2>
              <div>
                <div className={classes.formGroupContainer}>
                  <FormGroup title='รหัสสินค้า'>
                    <input
                      type='text'
                      value={this.state.productCode}
                      onChange={e => this.setState({ productCode: e.target.value })} />
                  </FormGroup>
                </div>
                <div className={classes.formGroupContainer}>
                  <FormGroup title='บริษัทจำหน่าย'>
                    <div className='Select-height-38 margin-vertical-10'>
                      <Select
                        name='company'
                        value={this.state.companyCode}
                        clearable={false}
                        placeholder='กรุณาเลือกบริษัทจำหน่าย'
                        options={companyOptions}
                        onChange={({ value }) => this.setState({ companyCode: value })} />
                    </div>
                  </FormGroup>
                </div>
                <div className={classes.formGroupContainer}>
                  <FormGroup title='ชื่อสินค้า'>
                    <input
                      type='text'
                      value={this.state.productName}
                      onChange={e => this.setState({ productName: e.target.value })} />
                  </FormGroup>
                </div>
                <div className={classes.formGroupContainer}>
                  <FormGroup title='หมวดหมู่สินค้า'>
                    <div className='Select-height-38 margin-vertical-10'>
                      <Select.Creatable name='tags' multi value={this.state.tags}
                        options={tagOptions}
                        placeholder='กรุณาเพิ่มหมวดหมู่สินค้า'
                        promptTextCreator={(tag) => `เพิ่มหมวดหมู่สินค้า: ${tag}`}
                        noResultsText=''
                        shouldKeyDownEventCreateNewOption={(keyCode) => keyCode === 13}
                        onChange={(tags) => this.setState({
                          tags: tags.map(({ className, label, value }) =>
                            ({
                              className,
                              label: label.replace(PROMPT_TEXT, ''),
                              value: value.replace(PROMPT_TEXT, '')
                            })
                          )
                        })} />
                    </div>
                  </FormGroup>
                </div>
                <div className={classes.formGroupContainer}>
                  <FormGroup title='Generic name'>
                    <input
                      type='text'
                      value={this.state.genericName}
                      onChange={e => this.setState({ genericName: e.target.value })} />
                  </FormGroup>
                </div>
                <div className={classes.formGroupContainer}>
                  <FormGroup title='กลุ่มสินค้า'>
                    <input
                      type='text'
                      value={this.state.productGroup}
                      onChange={e => this.setState({ productGroup: e.target.value })} />
                  </FormGroup>
                </div>
                <div className={classes.formGroupContainer}>
                  <FormGroup title='ลำดับสินค้าใหม่'>
                    <input
                      type='text'
                      value={this.state.promotional}
                      onChange={e => this.setState({ promotional: e.target.value })} />
                  </FormGroup>
                </div>
                <div className={classes.formGroupContainer}>
                  <FormGroup title='ลำดับสินค้าขายดี'>
                    <input
                      type='text'
                      value={this.state.recommended}
                      onChange={e => this.setState({ recommended: e.target.value })} />
                  </FormGroup>
                </div>
                <div className={classes.formGroupContainer}>
                  <FormGroup title='สินค้าขาดชั่วคราว'>
                    <input
                      type='checkbox'
                      checked={this.state.outOfStock}
                      onChange={() => this.setState({ outOfStock: !this.state.outOfStock })} />
                  </FormGroup>
                </div>
                <div className={classes.formGroupContainer}>
                  <FormGroup title='รายละเอียดสินค้า'>
                    <textarea
                      value={this.state.description}
                      onChange={(e) => this.setState({ description: e.target.value })} />
                  </FormGroup>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.gridContainer}>
          <div className={classes.inputSection}>
            <h2 className={classes.sectionHead}>ภาพสินค้า</h2>
            <div>
              <div className={classes.formGroupContainer}>
                <div className={classes.formGroupTitle}>
                  <span>เพิ่มภาพ Thumbnail</span>
                  <img
                    style={{ verticalAlign: 'top' }}
                    role='presentation'
                    className={classes.btnImage}
                    src='/images/icon-camera.png'
                    onClick={() => this.refs.thumbnailChooser.click()} />
                  <input
                    type='file'
                    ref='thumbnailChooser'
                    onChange={this._onThumbnailChosen} />
                </div>
                <div className={classes.images}>
                  <img
                    role='presentation'
                    className={classes.thumbnail}
                    src={this.state.imagePath} />
                </div>
              </div>
              <div className={classes.formGroupContainer}>
                <div className={classes.formGroupTitle}>
                  <span>เพิ่มรูปประกอบ</span>
                  <img
                    style={{ verticalAlign: 'top' }}
                    role='presentation'
                    className={classes.btnImage}
                    src='/images/icon-camera.png'
                    onClick={() => this.refs.imagesChooser.click()} />
                  <input
                    type='file'
                    multiple
                    ref='imagesChooser'
                    onChange={this._onImagesChosen} />
                </div>
                <div className={classes.images}>
                  {(this.state.productImages || []).map(({ id, imagePath }, index) =>
                    <div key={index} className={classes.imageContainer}>
                      <img className={classes.image} role='presentation' src={`${imagePath}?timestamp=1`} onClick={() => this._onOpenModal(imagePath)} />
                      <div className={classes.btnRemove} onClick={() => this._onImageRemove(id)}>
                        <img src='/images/icon-bin-orange.png' alt='icon-bin' />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.state.modalVisible && (
          <div className='overlay'>
            <div className={`overlay-cell ${classes.modal}`} onClick={this._onCloseModal}>
              <img
                role='presentation'
                src={this.state.modalImagePath} />
            </div>
          </div>
        )}
        <div className={classes.gridContainer}>
          <div className={classes.inputSection}>
            <h2 className={classes.sectionHead}>ข้อมูลของสินค้าแต่ละหน่วย</h2>
            <div className={classes.tabBar}>
              {(this.state.units || []).map(({ unit, unitId, barcode }) =>
                <div
                  key={unitId}
                  className={`${classes.tabMenu} ${`${unitId}` === this.state.activeTab ? classes.active : ''}`}
                  onClick={() => this.setState({ activeTab: `${unitId}` })}>
                  {unit}
                </div>
              )}
            </div>
            <div className={classes.formGroupContainer}>
              <FormGroup title='Barcode'>
                <input
                  type='text'
                  value={this._unitValue(this.state.activeTab, 'barcode')}
                  onChange={e => this._onUnitChange(this.state.activeTab, 'barcode', e.target.value)} />
              </FormGroup>
            </div>
            <div className={classes.formGroupContainer}>
              <FormGroup title='จำนวนต่อหน่วย'>
                <input
                  type='text'
                  value={this._unitValue(this.state.activeTab, 'perUnit')}
                  onChange={e => this._onUnitChange(this.state.activeTab, 'perUnit', e.target.value, 'number')} />
              </FormGroup>
            </div>
            <div className={classes.formGroupContainer}>
              <FormGroup title='ราคาขายปลีก'>
                <input
                  type='text'
                  value={parseFloat(this._unitValue(this.state.activeTab, 'retail'), 10)}
                  onChange={e => this._onUnitChange(this.state.activeTab, 'retail', e.target.value, 'number')} />
              </FormGroup>
            </div>
            <div className={classes.formGroupContainer}>
              <FormGroup title='ราคาขายส่ง 1'>
                <input
                  type='text'
                  value={parseFloat(this._unitValue(this.state.activeTab, 'wholesale1'), 10)}
                  onChange={e => this._onUnitChange(this.state.activeTab, 'wholesale1', e.target.value, 'number')} />
              </FormGroup>
            </div>
            <div className={classes.formGroupContainer}>
              <FormGroup title='ราคาขายส่ง 2'>
                <input
                  type='text'
                  value={parseFloat(this._unitValue(this.state.activeTab, 'wholesale2'), 10)}
                  onChange={e => this._onUnitChange(this.state.activeTab, 'wholesale2', e.target.value, 'number')} />
              </FormGroup>
            </div>
            <div className={classes.formGroupContainer}>
              <FormGroup title='ราคาขายส่ง 3'>
                <input
                  type='text'
                  value={parseFloat(this._unitValue(this.state.activeTab, 'wholesale3'), 10)}
                  onChange={e => this._onUnitChange(this.state.activeTab, 'wholesale3', e.target.value, 'number')} />
              </FormGroup>
            </div>
            <div className={classes.formGroupContainer}>
              <FormGroup title='ราคาขายส่ง 4'>
                <input
                  type='text'
                  value={parseFloat(this._unitValue(this.state.activeTab, 'wholesale4'), 10)}
                  onChange={e => this._onUnitChange(this.state.activeTab, 'wholesale4', e.target.value, 'number')} />
              </FormGroup>
            </div>
          </div>
        </div>
        <div className={classes.buttonContainer}>
          <div className={`btn ${classes.btn}`} onClick={this._onSave}>
            {this.state.saving ? <Loader /> : <span>บันทึก</span>}
          </div>
          <div
            style={{ marginLeft: 60 }}
            className={`btn btn-orange ${classes.btn}`}
            onClick={() => this.context.router.replace('/admin/products')}>
            <span>ยกเลิก</span>
          </div>
        </div>
      </section>
    )
  }
}

export default AdminProduct



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminProduct/AdminProduct.js